import { TaxiVoiceProvider } from "@taunggyi-plus/taxi-feature";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import {
  SupportChat,
  CustomerEvents,
  CustomerHome,
  CustomerInformationDialog,
  CustomerRoleMore,
  CustomerOrders,
  CustomerSearch,
  CustomerServiceBrowser,
} from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import { NotificationCenter } from "@taunggyi-plus/notifications";

const authConfig = {
  appId: "customer",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <TaxiVoiceProvider>
        <PlatformApp
          config={getAppConfig("customer")}
          contentOwnsHeading={["orders"]}
          informationContent={(locale, id, onClose) => (
            <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
          )}
          homeContent={(locale) => <CustomerHome locale={locale} />}
          searchContent={(locale) => <CustomerSearch locale={locale} />}
          featureContent={(locale) => <CustomerServiceBrowser locale={locale} />}
          eventContent={(locale) => <CustomerEvents locale={locale} />}
          ordersContent={(locale) => <CustomerOrders locale={locale} />}
          notificationContent={(locale) => (
            <NotificationCenter
              locale={locale}
              appId="customer"
              webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
            />
          )}
          moreContent={(locale, onLocaleChange, onOpenPreferences) => (
            <CustomerRoleMore
              locale={locale}
              onLocaleChange={onLocaleChange}
              onOpenPreferences={onOpenPreferences}
            />
          )}
        />
        <SupportChat />
      </TaxiVoiceProvider>
    </AuthProvider>
  </StrictMode>,
);
